import { CreateDiarioObrasResponse } from "../../../data/daos/create/create_diario_obra";
import { ICreateDiarioObraAtividadesUseCase } from "../../../presentation/useCases/create/create_diario_obra_atividades_use_case";
import { ICreateDiarioObraEfetivoUseCase } from "../../../presentation/useCases/create/create_diario_obra_efetivo_use_case";
import { ICreateDiarioObraEquipamentoUseCase } from "../../../presentation/useCases/create/create_diario_obra_equipamento_use_case";
import { ICreatDiarioObraUseCase } from "../../../presentation/useCases/create/create_diario_obra_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// CreateDiarioObraAtividadesUseCase


export class CreateDiarioObraAtividadesUseCase implements ICreateDiarioObraAtividadesUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async createDiarioObraAtividades(IdDiarioObras: number | null, Descricao: string | null, IdFornecedor: number | null, TipoMaoDeObra: number | null, Ordem: number | null): Promise<void> {
    
    await this.repository.createDiarioObraAtividades(
      IdDiarioObras, Descricao, IdFornecedor, TipoMaoDeObra, Ordem
    );
  }
}
